import script from "./StudentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentTable.vue?vue&type=script&setup=true&lang=js"

import "./StudentTable.vue?vue&type=style&index=0&id=1723805c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1723805c"]])

export default __exports__